import VideoSpotlight from './VideoSpotlight';
export default VideoSpotlight;
